import { TextButton } from '@zillow/constellation-10';
import styled from 'styled-components';

export const HomeLoansDashboardLinkAnchor = styled(TextButton)`
    font-weight: 400;
`;
